import { getEddApi } from "../api/account";
import { setEddData } from "../redux/reducer/edd";

export class Edd {
  constructor() {
    this.status = null;
    this.type = null;
    this.data = {
      id: null,
      user_id: null,
      edd_type: null,
      src_sof: null,
      src_occupation: null,
      src_bank_ref: null,
      status_sof: null,
      status_occupation: null,
      status_bank_ref: null,
      opt_key_reason_sof: null,
      opt_key_reason_occupation: null,
      opt_key_reason_bank_ref: null,
      rejected_type: null,
      status: null,
      submitted_at: null,
      flags: null,
      start_date: null,
      end_date: null,
      terminate_date: null,
      updatedAt: null,
      createdAt: null,
      reason_sof: {
        value: null,
        text: null
      },
      reason_occupation: {
        value: null,
        text: null
      },
      reason_bank_ref: {
        value: null,
        text: null
      }
    };
  }

  async initialize(dispatch) {
    try {
      const response = await this.getEdd();
      this.data = response;
      if (dispatch) {
        dispatch(setEddData(response));
      }
      this.status = 'success';
      return this.data;
    } catch (error) {
      this.status = 'error';
      console.error('Failed to initialize EDD data:', error);
    }
  }

  async getEdd() {
    try {
      const { data } = await getEddApi();
      return data;
    } catch (error) {
      console.error('Failed to get EDD data:', error);
      throw error;
    }
  }

  async refetch() {
    try {
      const response = await this.getEdd();
      this.data = response;
      this.status = 'success';
      return response;
    } catch (error) {
      this.status = 'error';
      console.error('Failed to refetch EDD data:', error);
      throw error;
    }
  }
}
